import { $api } from "@/lib/api-client";

export const useFetchUserChildren = (
  walletAddress: string | undefined,
  enabled = true,
) => {
  const result = $api.useQuery(
    "get",
    "/user/children/{wallet_address}",
    {
      params: { path: { wallet_address: walletAddress! } },
    },
    { enabled: enabled && !!walletAddress },
  );

  return {
    data: result.data?.data,
    error: result.error,
    isLoading: result.isLoading,
  };
};
